import ReportConversationPage from './ReportConversationPage';

export default ReportConversationPage;
